<template>
	<div>
		<el-card>
			<el-button type="primary" slot="header" @click="back()" v-if="type === 2">{{$t('lang.venue.btn_back_first')}}</el-button>
			<el-button type="primary" slot="header" @click="add()" v-if="type === 1">{{$t('lang.venue.btn_addVenueType_first')}}</el-button>
			<el-button type="primary" slot="header" @click="add()" v-if="type === 2">{{$t('lang.venue.btn_addVenueType_sec')}}</el-button>
			<el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
				<el-table-column type="selection" width="55" v-if="venueTypeManagecheckbox"></el-table-column>
				<el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px"></el-table-column>
				<el-table-column prop="name" :label='column'></el-table-column>
				<el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right" :width="require('@/config/enum').opr_width3">
					<template slot-scope="scope">
						<el-button @click="details(scope.row.id)" v-if="type === 1">{{$t('lang.btn_detail')}}</el-button>
						<el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
						<!-- <el-button class="orange" @click="deleteOne(scope.row.id)">{{$t('lang.btn_delete')}}</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pageNo"
				:page-sizes="[10, 20, 30, 50]"
				:page-size="pageSize"
				layout="sizes, prev, pager, next, jumper"
				:page-count="pageCount"
				/>
		</el-card>
		
		<el-dialog :title=title :visible.sync="isPopupPage" :close-on-click-modal="false"
		  center
		  top="130px"
		  width="600px"
		  @closed="handleDialogClosed">
		  <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws6" :label-suffix="require('@/config/enum').c_colon">
		    <el-form-item :label="$i18n.t('lang.venue.label_venueName')" prop="name" class="input-width">
		      <input style="display: none"/>
		      <el-input v-model="form.name" :placeholder="$t('lang.venue.tip_resourceName')" maxlength="20"></el-input>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <!-- <el-button @click="resetForm()">{{$t('lang.btn_rest')}}</el-button> -->
		    <el-button type="primary" @click="save('form')" :disabled="isDisabled">{{$t('lang.btn_save')}}</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
/**
 *@ClassName:venueType
 *@Description:资源点位类型设置
 *@author:李立斌
 *@Copyright:格众科技
 *@date:2021-06-15
 */
import { mapGetters } from 'vuex'

export default {
	data() {
	  return {
	    isDisabled: true, // 保存的可点击
	    type: 1, // 1:一级类型 2：二级类型
	    isPopupPage: false, // 弹框的显示控制
	    isAdd: false, // 标识新增(true)或编辑(false)
	    id: 0, // parentId
	    editId: '', // 正在编辑的ID
	    title: '', // 弹窗标题
	    isTitle: '', // 弹窗label
	    column: this.$i18n.t('lang.venue.label_resourceType'), // 列表标题
	    pageCount: 0, // 总页数
	    pageNo: 1, // 页数
	    pageSize: 10, // 每页显示数量
	    tableData: [], // 列表数据
	    multipleSelection: [], // 多选框
	    venueTypeManagecheckbox: require('@/config/enum').venueTypeManagecheckbox, // 是否隐藏复选框
	    form: {
	      name: ''
	    }, // 弹窗列表数据
	    rules: {
	      name: [{ required: true, message: this.$i18n.t('lang.venue.tip_resourceName'), trigger: 'blur' }]
	    }
	  }
	},
	created() {
		this.getData()
	},
	watch: {
	form: {
	  handler(newVal, oldVal) {
		// form数据变化时 会调用此方法
		let tempRule = JSON.stringify(newVal)
		if (tempRule === this.saveData) {
		  // 没变
		  this.isDisabled = true
		} else {
		  // 变了
		  this.isDisabled = false
		}
	  },
	  deep: true,
	  immediate: true
	}
	},
	methods: {
		indexMethod(index) {
		  return (this.pageNo - 1) * this.pageSize + index + 1
		},
		// 表格斑马
		tableRowClassName({ row, rowIndex }) {
			return rowIndex % 2 === 0 ? 'row-dark' : ''
		},
		// 多选框
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		// 获取表格数据
		getData() {
		  let loading = this.$loading()
		  this.$get(`/venue/getTypes?pageSize=${this.pageSize}&pageNo=${this.pageNo}` + (this.id ? `&parentId=${this.id}` : '')).then(
			res => {
			  loading.close()
			  if (res && res.errCode === 0) {
				this.tableData = res.list
				this.pageCount = res.pageCount
			  }
			},
			error => {
			  loading.close()
			  this.$message.error(error)
			}
		  )
		},
		// 返回
		back() {
		  if (this.type === 2) {
			this.type = 1
			this.column = this.$i18n.t('lang.venue.label_resourceType')
			this.id = 0
		  }
		  this.commit()
		},
		// 添加
		add() {
		  if (this.type === 1) {
			this.title = this.$i18n.t('lang.venue.btn_addVenueType_first')
		  } else if (this.type === 2) {
			this.title = this.$i18n.t('lang.venue.btn_addVenueType_sec')
		  }
		  this.form.name = ""
		  this.isPopupPage = true
		  this.isAdd = true
		},
		// 编辑
		edit(rowData) {
		  if (this.type === 1) {
			this.title = this.$i18n.t('lang.venue.title_editVenueType_first')
		  } else if (this.type === 2) {
			this.title = this.$i18n.t('lang.venue.title_editVenueType_sec')
		  }
		  this.editId = rowData.id
		  this.form.name = rowData.name
		  this.form.isPropertyShow = rowData.isPropertyShow
		  this.isPopupPage = true
		  this.isAdd = false
		  this.saveData = JSON.stringify(this.form)
		},
		// 详情
		details(id) {
		  if (this.type === 1) {
			this.type = 2
			this.column = this.$i18n.t('lang.venue.label_secResourceType') 
		  }
		  this.id = id
		  this.commit()
		},
		// 保存
		save(formName) {
		  this.$refs[formName].validate(valid => {
			if (valid) {
			  if (this.isAdd) {
				let params = {
				  parentId: this.id,
				  name: this.form.name,
				}
				let loading = this.$loading()
				this.$post(`/venue/createType`, params).then(
				  res => {
					loading.close()
					if (res && res.errCode === 0) {
					  this.$message.success(this.$i18n.t('lang.lab_save_success'))
					  this.isPopupPage = false
					  this.commit()
					}
				  },
				  error => {
					loading.close()
					this.$message.error(error)
				  }
				)
			  } else {
				let loading = this.$loading()
				let params = {
					typeId: this.editId,
				  name: this.form.name,
				  parentId: this.id,
				}
				this.$patch(`/venue/updateType`, params).then(
				  res => {
					loading.close()
					if (res && res.errCode === 0) {
					  this.$message.success(this.$i18n.t('lang.lab_save_success'))
					  this.isPopupPage = false
					  this.commit()
					}
				  },
				  error => {
					loading.close()
					this.$message.error(error)
					this.isPopupPage = false
				  }
				)
			  } 
			}
		  })
		},
		// 更新
		commit() {
		  this.pageNo = 1
		  this.getData()
		},
		// 监听关闭dialog
		handleDialogClosed() {
		  this.resetForm()
		},
		// 翻页
		handleCurrentChange(val) {
		  this.pageNo = val
		  this.getData()
		},
		// 切换每页显示多少数据
		handleSizeChange(val) {
		  this.pageNo = 1
		  this.pageSize = val
		  this.getData()
		}
	}
}
</script>

<style>
</style>
